/**
 * @module FieldControls
 */
import { FormHelperText, TextField, Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
/**
 * Field control that represents a PageCount field. Available values will be populated from the FieldSettings.
 */
export const PageCount = props => {
  var _props$localization;
  const localization = deepMerge(defaultLocalization.pageCount, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.pageCount);
  const initialState = props.fieldValue || props.actionName === 'new' && changeTemplatedValue(props.settings.DefaultValue) || null;
  const [value, setValue] = useState(initialState);
  const handleChange = e => {
    var _props$fieldOnChange;
    setValue(e.target.value);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, e.target.value);
  };
  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
        autoFocus: props.autoFocus,
        name: props.settings.Name,
        type: "number",
        label: props.settings.DisplayName,
        value: value,
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly,
        placeholder: props.settings.DisplayName,
        id: props.settings.Name,
        fullWidth: true,
        onChange: handleChange
      }), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description));
    case 'browse':
    default:
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        gutterBottom: true
      }, props.fieldValue != null ? /*#__PURE__*/React.createElement(React.Fragment, null, +props.fieldValue < 0 ? localization[props.fieldValue] : props.fieldValue) : localization.noValue));
  }
};
//# sourceMappingURL=page-count.js.map